export class POCloseRequest {
    purchaseOrderId: number;
    reasonClosing: string;
}